import React from "react";

function ClicksPage() {
  return <div>ClicksPage</div>;
}

export default ClicksPage;
